package com.daytimegaming.ourdailyfinances.data.repository

import com.daytimegaming.ourdailyfinances.data.network.service.BudgetService
import com.daytimegaming.ourdailyfinances.domain.Response
import com.daytimegaming.ourdailyfinances.domain.model.Budget
import com.daytimegaming.ourdailyfinances.domain.repository.BudgetRepository
import kotlinx.coroutines.flow.Flow
import kotlinx.coroutines.flow.flow

class BudgetRepositoryImpl(private val service: BudgetService) : BudgetRepository {

    override fun getBudgets(): Flow<Response<List<Budget>>> = flow {
        emit(Response.Loading)
        try {
            val response = service.getBudgets()
            val budgets = response.budgets.map { it.toDomain() }
            emit(Response.Success(budgets))
        } catch (e: Exception) {
            emit(Response.Error(e.message ?: "Failed to load budgets"))
        }
    }

    override suspend fun createBudget(
        name: String,
        categories: List<String>,
        targetValue: Double,
        dashboardIds: List<String>?
    ): Response<Budget> {
        return try {
            val dto = service.createBudget(name, categories, targetValue, dashboardIds)
            Response.Success(dto.toDomain())
        } catch (e: Exception) {
            Response.Error(e.message ?: "Failed to create budget")
        }
    }

    override suspend fun updateBudget(
        budgetId: String,
        name: String?,
        categories: List<String>?,
        targetValue: Double?,
        dashboardIds: List<String>?
    ): Response<Budget> {
        return try {
            val dto = service.updateBudget(budgetId, name, categories, targetValue, dashboardIds)
            Response.Success(dto.toDomain())
        } catch (e: Exception) {
            Response.Error(e.message ?: "Failed to update budget")
        }
    }

    override suspend fun deleteBudget(budgetId: String): Response<Unit> {
        return try {
            service.deleteBudget(budgetId)
            Response.Success(Unit)
        } catch (e: Exception) {
            Response.Error(e.message ?: "Failed to delete budget")
        }
    }
}
